export default {
    GroupId: '',
    Group: {},
    Groups: [],
    TotalInfo: {
        count: 0,
        limit: 20,
        page: 1,
        rows: []
    },
    GroupPage: {},
    GroupLogin: {}
}